import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { aircraftCategories } from './aircraft-category-list';
import * as contracts from './contracts';

@Injectable()
export class AircraftCategoriesService implements contracts.IAircraftCategoriesService {
  constructor() { }

  getAircraftCategoryList(
    request: contracts.GetAircraftCategoryListRequest
  ): Observable<contracts.GetAircraftCategoryListResponse> {
    const response = new contracts.GetAircraftCategoryListResponse();
    response.entities = aircraftCategories;

    return of(response);
  }
}
